<template>
  <div>
    <Dialog header="Đổi mật khẩu" class="w-[550px]" v-model:visible="showDialog" modal :closable="closable"
      draggable="false">

      <div class="py-4">
        <Message>Để đảm bảo ATTT, vui lòng thay đổi mật khẩu định kỳ/mật khẩu mặc định</Message>
      </div>

      <Form v-slot="$form" @submit="onFormSubmit" class="space-y-4" :resolver="resolver" :initialValues="initialValues"
        validateOnMount :validateOnValueUpdate="false">
        <div class="flex flex-col md:flex-row md:items-center">
          <label for="currentPassword" class="md:w-1/3">Mật khẩu hiện tại: <span class="text-red-500">*</span></label>
          <div class="md:w-2/3">
            <Password id="currentPassword" name="old_password" fluid :feedback="false" toggleMask class="w-full" />
            <Message v-if="$form.old_password?.invalid" severity="error" size="small" variant="simple" class="mt-1">{{
              $form.old_password.error?.message }}
            </Message>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:items-center">
          <label for="new_password" class="md:w-1/3">Mật khẩu mới: <span class="text-red-500">*</span></label>
          <div class="md:w-2/3">
            <Password id="new_password" name="new_password" fluid toggleMask :feedback="false" class="w-full" />
            <Message v-if="$form.new_password?.invalid" v-for="(error, index) of $form.new_password.errors" :key="index"
              severity="error" size="small" variant="simple">{{ error.message }}</Message>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:items-center">
          <label for="confirmPassword" class="md:w-1/3">Xác nhận mật khẩu: <span class="text-red-500">*</span></label>
          <div class="md:w-2/3">
            <Password id="confirmPassword" name="confirm_password" fluid :feedback="false" toggleMask class="w-full" />
            <Message v-if="$form.confirm_password?.invalid" severity="error" class="mt-1" size="small" variant="simple">
              {{
                $form.confirm_password.error?.message }}
            </Message>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:items-center">
          <Button type="submit" fluid label="Đổi mật khẩu" class="w-full" />
        </div>
      </Form>
    </Dialog>
  </div>
</template>

<script setup>
import { zodResolver } from '@primevue/forms/resolvers/zod';
const { $api } = useNuxtApp();
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  closable: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['open-dialog', 'close-dialog', 'submit']);

const resolver = ref(zodResolver(schemaValidChangePassword))
const initialValues = ref({
  old_password: '',
  new_password: '',
  confirm_password: ''
});
const showDialog = ref(props.visible);

watch(() => props.visible, (newVal) => {
  showDialog.value = newVal;
});

const onFormSubmit = async (form) => {
  console.log(form);

  if (form.valid) {
    useLoading(true)
    try {
      const base64Params = {
        old_password: btoa(form.values.old_password),
        new_password: btoa(form.values.new_password),
        confirm_password: btoa(form.values.confirm_password)
      };
      const resp = await $api(`/api/nguoi-dung/change-password`, {
        method: 'PUT',
        body: { ...base64Params }
      });
      if (resp.message) {
        showToast('success', 'Cập nhật mật khẩu thành công');
        emit('close-dialog');
      }
    } catch (error) {
      showToast('error', error.data?.message || error.toString() || 'Có lỗi');
    }
    finally {
      useLoading(false)
    }
  }
};

</script>

<style scoped>
.p-field {
  margin-bottom: 1rem;
}
</style>
